module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/35ca1b46b378e4280df8a864e6b92809.png";